<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #544d84">    
    <h4 class="modal-title w-100">{{x_titulo}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
</div>
  
<!--Body-->
<div class="modal-body">
    
     
      <mdb-card>
        <div class="table-responsive">
        <table mdbTable hover="true">
            <thead>
              <tr>
                <th *ngFor="let head of headElements" scope="col">{{head}}</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let modalidad of listModalidad.response.list | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
                <th>{{modalidad.name}}</th>                
                <td><button type="button" (click)="onSeleccionar(modalidad)" color="deep-purple" outline="true" class="btn-sm" mdbWavesEffect mdbBtn>Seleccionar</button></td>
              </tr>
            </tbody>
          </table>
          </div>
            <div class="text-center">
              
              <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
                [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listModalidad.response.list.length">
              </ngb-pagination>
              
            </div>
                
      </mdb-card>
    <br>
  
</div>  
  <!--Footer-->
<div class="modal-footer justify-content-center">

</div>


